import { AppBar, Container, MenuItem, Select, ThemeProvider, Toolbar, Typography, createTheme, makeStyles } from '@material-ui/core'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CryptoState } from '../CryptoContext'
import Authmodal from './Authentication/Authmodal'
import Usersidebar from './Authentication/Usersidebar'

const useStyles = makeStyles(()=>({
    title:{
        flex:1,
        color:"#e64072",
        fontFamily:"Montserrat",
        fontWeight:"bold",
        cursor:"pointer"
    }
}))

function Header() {
    const classes = useStyles()

    const navigate = useNavigate()

    const {currency,setCurrency,user} = CryptoState()

    const darkTheme = createTheme({
        palette:{
            primary:{
                main:"#fff",
            },
            type:"dark",
        }
    })

  return (
    <ThemeProvider theme={darkTheme}>
    <AppBar color='transparent' position='static'>
        <Container>
            <Toolbar>
                <Typography onClick={()=>{navigate('/')}} className={classes.title} variant='h6'>Crypto Vortex</Typography>
                <Select variant='outlined' style={{
                    width:100,
                    height:40,
                    marginLeft:15,
                    marginRight:15,
                }} 
                MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: '#2525A4', // Set background color for the dropdown menu
                      },
                    },
                  }}
                
                value={currency} onChange={(e)=>{setCurrency(e.target.value)}}>
                    <MenuItem value={"INR"}>INR</MenuItem>
                    <MenuItem value={"USD"}>USD</MenuItem>
                    <MenuItem value={"EUR"}>EUR</MenuItem>
                </Select>
                {user?<Usersidebar/>:<Authmodal/>}
            </Toolbar>
        </Container>
    </AppBar>
    </ThemeProvider>
  )
}

export default Header